<template>
  <div class="ranking-contaiter">
    <div class="topbgc">
      <van-nav-bar title="排行榜" left-arrow>
        <template #left>
          <img
            class="leftImg"
            @click="$router.back(-1)"
            src="@/assets/picture/fanhui@2x.png"
            alt=""
          />
        </template>
        <template #right>
          <div class="rightbox" @click="ruleshow = true">
            <h1>活动规则</h1>
          </div>
        </template>
      </van-nav-bar>
      <!-- 弹出框 -->
      <van-popup
        v-model="ruleshow"
        closeable
        close-icon="close"
        position="center"
        :style="{ height: '55%' }"
      >
        <img class="dialogImg" src="@/assets/picture/hdgz@2x.png" />
        <h3>题型说明</h3>
        <div class="state-box">
          <p class="state-text" v-for="item in this.descriptions" :key="item">
            {{ item }}
          </p>
        </div>
        <!-- <p class="state-text">
        总共{{ this.total }}道题，每道题的时间为{{
          this.answerTime
        }}秒。{{ this.countList[0] }}道单选题、{{
          this.countList[1]
        }}道多选题、{{ this.countList[2] }}道填空题、{{
          this.countList[3]
        }}道问答题、{{ this.countList[4] }}道看图猜诗、{{
          this.countList[5]
        }}道宫格题点字成诗。
      </p> -->
        <h3 class="h3s">答题次数</h3>
        <div v-if="this.gameNums > 0" class="state-texts">
          <p class="state-days" v-if="this.gameNumsType == 1">
            活动期间总共答{{ this.gameNums }}次
          </p>
          <p class="state-days" v-else>每天可以答{{ this.gameNums }}次</p>
        </div>
        <div class="state-texts" v-else>不限次数</div>
      </van-popup>
      <div class="middlebox">
        <div class="textleft">
          <div class="numpeople">
            <h2>参与人数</h2>
            <div v-if="this.peopleCount" class="playci">
              {{ this.peopleCount }}<span class="playcis">人</span>
            </div>
            <div v-else class="playci">0<span class="playcis">人</span></div>
          </div>
        </div>
        <div class="textright">
          <div class="persontime">
            <h2>参与人次</h2>
            <div v-if="this.participantsNums" class="playnum">
              {{ this.participantsNums }}<span class="playnums">人次</span>
            </div>
            <div v-else class="playnum">
              0 <span class="playnums">人次</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rightbotm">
        <img class="botImg" src="@/assets/picture/renwu@2x.png" alt="" />
      </div>
      <div class="toprank">
        <div class="rankbox3">
          <div class="boxs">
            <span class="text-name">今日排名</span>
            <div class="unit-box">
              <span v-if="toplist.index" class="nums">{{ toplist.index }}</span>
              <span v-else class="nums">-</span>
              <span class="unit">名</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="boxs">
            <span class="text-name">答对</span>
            <div class="unit-box">
              <span v-if="toplist.answerNums" class="nums">{{
                toplist.answerNums
              }}</span>
              <span v-else class="nums">-</span>

              <span class="unit">道</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="boxs">
            <span class="text-name">用时</span>
            <div class="unit-box">
              <span v-if="toplist.useTime" class="nums">{{
                toplist.useTime
              }}</span>
              <span v-else class="nums">-</span>
              <span class="unit">秒</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="state-box"> -->
    <!-- <p class="state-text" v-for="item in this.descriptions" :key="item">
        {{ item }}
      </p>
    </div> -->
    <div style="margin-top: 100px">
      <van-tabs v-model="active" @click="onClick">
        <!-- 排行榜 -->
        <van-tab>
          <template #title>
            <img
              v-show="flag"
              class="tanktab"
              src="@/assets/phb@2x.png"
              alt=""
            />
            <img
              v-show="!flag"
              class="tanktabas"
              src="@/assets/phbweixuan@2x.png"
              alt=""
            />
          </template>
          <div>
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="finishedText"
              :offset="10"
              @load="onload"
            >
              <van-cell v-for="(item, index) in rankList" :key="index">
                <div class="cell-box">
                  <div v-if="index === 0" class="sortone">{{ index + 1 }}</div>
                  <div v-else-if="index === 1" class="sortTwo">
                    {{ index + 1 }}
                  </div>
                  <div v-else-if="index === 2" class="sortThree">
                    {{ index + 1 }}
                  </div>
                  <div v-else class="sort">{{ index + 1 }}</div>
                  <div class="headImg">
                    <img
                      v-if="!item.header"
                      class="img"
                      src="@/assets/renwu1@2x.png"
                      alt=""
                    />
                    <img class="headItem" v-else :src="item.header" alt="" />
                  </div>
                  <div class="resultBox">
                    <span class="resulName">{{ item.nickName }}</span>
                    <div class="tewoBox">
                      <div class="resultNus">
                        答对<i class="redmus">{{ item.answerNums }}</i
                        >题
                      </div>
                      <div class="resultNu">
                        用时<i class="redmus">{{ item.useTime }}</i
                        >秒
                      </div>
                    </div>
                  </div>
                  <div class="topBox">
                    <img
                      v-if="index == 0"
                      class="topOne"
                      src="@/assets/picture/zy@2x.png"
                      alt=""
                    />
                    <img
                      v-if="index == 1"
                      class="topTwo"
                      src="@/assets/picture/by@2x.png"
                      alt=""
                    />
                    <img
                      v-if="index == 2"
                      class="topThree"
                      src="@/assets/picture/th@2x.png"
                      alt=""
                    />
                  </div>
                </div>
              </van-cell>
            </van-list>
          </div>
        </van-tab>
        <!-- 答案 -->
        <van-tab
          ><template #title>
            <img
              v-show="flag2"
              class="tanktab"
              src="@/assets/daan@2x.png"
              alt=""
            />
            <img
              class="tanktabs"
              v-show="!flag2"
              src="@/assets/daanweixuan@2x.png"
              alt=""
            />
          </template>
          <template>
            <div class="blankbox" v-show="answerList.length == 0">
              <img class="blankImg" src="@/assets/kongbaiye@2x.png" alt="" />
              <h4>暂无答案，赶快去答题哦~</h4>
            </div>
            <div>
              <van-tabs v-model="count" title-inactive-color="#9C9C9C">
                <van-tab
                  v-for="(item, index) in answerList"
                  :key="index"
                  title-class="childrenA"
                >
                  <template #title>
                    <div class="tabBgc" @click="answerInfo(item)">
                      <div class="tabtexts">
                        第{{ answerList.length - index }}次
                      </div>
                    </div>
                  </template>
                  <div class="transcript">
                    <div class="onesBox">
                      <span class="tranBox">成绩</span>
                      <span class="numsBox">{{ list.score }}分</span>
                    </div>
                    <div class="onesBox">
                      <span class="tranBox">答对</span>
                      <span class="numsBox">{{ list.answerNums }}道</span>
                    </div>
                    <div class="onesBox">
                      <span class="tranBox">用时</span>
                      <span class="numsBox">{{ list.useTime }}s</span>
                    </div>
                    <div class="onesBox">
                      <span class="tranBox">答错</span>
                      <span class="numsBox">{{ list.incorrectlyNums }}道</span>
                    </div>
                  </div>
                  <div
                    class="allbox"
                    v-for="(item, index) in questionList"
                    :key="index"
                  >
                    <div class="firstBox">
                      <ul>
                        <li>
                          <div class="first-box">
                            <div class="serial">{{ index + 1 }}、</div>
                            <p class="topic-text" v-if="item.answerType != 5">
                              {{ item.title }}
                            </p>
                            <div
                              v-else-if="item.answerType == 5"
                              class="topic-text"
                            >
                              <img
                                class="photo"
                                :src="url + item.fileImg"
                                alt=""
                              />
                            </div>
                            <!-- <p class="topic-texts" v-else></p> -->
                            <div class="right-texts" v-if="item.isCorrect == 1">
                              正确
                            </div>
                            <div class="right-text" v-else>错误</div>
                          </div>
                          <div class="chunk-box">
                            <div class="answs">答案</div>
                            <div class="answs-text">
                              {{ item.correctAnswer }}
                            </div>
                            <!-- 解析 -->
                            <div class="analysis"></div>
                            <div class="anlysis-text"></div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </van-tab>
              </van-tabs>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import {
  getRankList,
  getUserRankInfo,
  getActionInfo,
  getAnswerRecord,
  getActionConfig,
  getAnswerRecordInfo,
} from "@/api/rank";
import Common from "@/components/comm";
export default {
  name: "ranking",
  components: {},
  props: {},
  data() {
    return {
      url: Common.getUrl(),
      ruleshow: false,
      isshow: false,
      count: 0,
      active: 0,
      flag: false, //tab切换
      flag2: false, //tab切换
      iscount: false,
      queryInfo: {
        pageNo: 0, //页数
        pageSize: 10, //页容量
      },
      loading: false, //上拉加载
      finished: false, //上拉加载完毕
      finishedText: "",
      toplist: [],
      rankList: [], //排行榜列表
      participantsNums: "", //参与人次
      peopleCount: "", //参与人数
      gameNums: "", //答题次数
      gameNumsType: "", //答题次数类型
      answerTime: "", //答题时间
      countList: [], //答题数量
      answerList: [], //tab
      total: "", //总题数
      descriptions: [], //题型说明
      tabnum: "",
      statisticsId: "",
      questionList: [], //tab列表
      list: [],
      firstId: "", //获取第一条id
      itemId: "", //tab点击id
    };
  },
  computed: {},
  watch: {},
  created() {
    let act = this.$route.query.active;
    if (act) {
      this.onClick(act);
    } else {
      this.onClick(0);
    }
    this.getUserRankInfos();
    this.getActionInfs();
    this.getAnswerRecords();
    this.getActionConfigs();
  },
  mounted() {},
  methods: {
    // tab获取答案记录
    async getAnswerRecords() {
      const { data: res } = await getAnswerRecord();
      this.answerList = res.data;
      this.firstId = this.answerList[0].id;
      this.getAnswerRecordInfos();
    },
    // 点击tabs获取下面数据
    answerInfo(item) {
      this.itemId = item.id;
      this.getAnswerRecordInfos();
    },
    // 获取答题详情
    async getAnswerRecordInfos() {
      if (this.statisticsId != this.itemId) {
        this.statisticsId = this.itemId;
      } else {
        this.statisticsId = this.firstId;
      }
      let statisticsId = { statisticsId: this.statisticsId };
      const { data: res } = await getAnswerRecordInfo(
        this.$qs.stringify(statisticsId)
      );
      this.list = res.data;
      this.questionList = res.data.questionList;
    },
    onload() {
      this.queryInfo.pageNo++;
      this.getRankLists();
    },
    // 获取排行榜
    getRankLists() {
      this.loading = true;
      getRankList(this.$qs.stringify(this.queryInfo)).then((res) => {
        this.rankList = this.rankList.concat(res.data.data);
        this.loading = false;
        if (res.data.data.length == 0) {
          this.finishedText = "已经到底了";
          this.finished = true;
        } else {
          this.finished = false;
        }
      });
    },
    // 获取顶部用户的排行信息
    async getUserRankInfos() {
      const { data: res } = await getUserRankInfo();
      this.toplist = res.data;
    },
    // 获取活动详情
    async getActionInfs() {
      const { data: res } = await getActionInfo();
      this.participantsNums = res.data.participantsNums; //参与人次
      this.peopleCount = res.data.peopleCount; //参与人数
      this.gameNums = res.data.gameNums; //答题次数
      this.gameNumsType = res.data.gameNumsType; //答题次数类型
      this.descriptions = res.data.descriptions; //题型说明
      if (res.data.descriptions) {
        this.descriptions = res.data.descriptions.split(";");
      }
    },
    // 点击tabs切换事件
    onClick(index) {
      if (index == 0) {
        this.flag = true;
        this.flag2 = false;
      }
      if (index == 1) {
        this.flag = false;
        this.flag2 = true;
      }
      this.active = index;
    },
    // 获取答题数量
    async getActionConfigs() {
      const { data: res } = await getActionConfig();
      this.answerTime = res.data.answerTime;
      this.countList = res.data.answerCount.split(",").map(Number);
      this.total = eval(this.countList.join("+")); //总和
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/assets/fonts/fonts.css";
.ranking-contaiter {
  height: 100vh;
}
.van-nav-bar {
  background: transparent;
}
.topbgc {
  position: relative;
  text-align: center;
  width: 100%;
  height: 460px;
  background: url("../../assets/picture/rankBgc@2x.png") no-repeat center center;
  background-size: 100% 100%;
}
.topImg {
  width: 100%;
  height: 460px;
}
::v-deep .van-nav-bar__content {
  height: 100px;
}
::v-deep .van-nav-bar__title {
  color: white;
}
::v-deep [class*="van-hairline"]::after {
  border: transparent;
}
.leftImg {
  width: 27px;
  height: 44px;
}
.rightbox {
  float: right;
  width: 158px;
  height: 46px;
  background: #ffffff;
  border-radius: 23px 0px 0px 23px;
  background-color: rgba(92, 114, 133);
}
::v-deep .van-nav-bar__right {
  padding: 0;
}
.dialogImg {
  position: relative;
  width: 584px;
  height: 543px;
}
h3 {
  position: absolute;
  top: 113px;
  left: 118px;
  font-family: "zihun";
  font-weight: 400;
  color: #b1420f;
  font-size: 30px;
}
.state-box {
  position: absolute;
  top: 164px;
  left: 117px;
  overflow-y: auto;
  height: 193px;
}
.state-text {
  width: 350px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #af7357;
  text-align: left;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 15px;
  margin-left: 20px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 8px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #bd937f;
}
.h3s {
  position: absolute;
  top: 398px;
  left: 118px;
  font-family: "zihun";
  font-weight: 400;
  color: #b1420f;
  font-size: 30px;
}
.state-texts,
state-days {
  position: absolute;
  top: 455px;
  left: 117px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #af7357;
  text-align: left;
  overflow-y: auto;
}
.rightbox h1 {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #f9e0b9;
}
::v-deep .van-popup {
  background-color: transparent;
}
::v-deep .van-popup__close-icon {
  position: relative;
  font-size: 52px;
}
::v-deep .van-popup__close-icon--top-right {
  right: 0;
}
.middlebox {
  display: flex;
  width: 654px;
  height: 250px;
  margin: 30px auto;
  background: url("../../assets/picture/juanzhou@2x.png") center center
    no-repeat;
  background-size: 100% 100%;
}
.centImg {
  width: 654px;
  height: 250px;
}
.textleft {
  width: 50%;
}
.numpeople,
.persontime {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 50px;
}
h2 {
  font-size: 28px;
  font-weight: 500;
  color: #232323;
}
.playci {
  font-size: 34px;
  font-weight: bold;
  color: #cb7c0a;
  margin-top: 10px;
}
.playcis {
  font-size: 28px;
  font-weight: bold;
  color: #cb7c0a;
}
.textright {
  width: 50%;
}
.playnum {
  font-size: 34px;
  font-weight: bold;
  color: #e45718;
  margin-top: 10px;
}
.playnums {
  font-size: 28px;
  font-weight: bold;
  color: #e45718;
}
.rightImg {
  width: 38px;
  height: 38px;
}
.share {
  font-size: 28px;
  font-weight: 500;
  color: #ababab;
  margin-left: 10px;
}
.rightbotm {
  position: absolute;
  bottom: -15px;
  right: 0;
}
.botImg {
  width: 179px;
  height: 223px;
}
.toprank {
  position: absolute;
  left: 50%;
  bottom: -159px;
  transform: translateX(-50%);
  width: 690px;
  height: 218px;
  background: #fff;
  box-shadow: 0px 7px 20px 0px rgba(0, 0, 0, 0.22);
  border-radius: 16px;
  margin: 0 auto;
  margin-top: -100px;
}
h6 {
  font-size: 28px;
  font-weight: 500;
  color: #202020;
  text-align: center;
  padding: 30px 0 20px 0;
}
.ranknums {
  font-size: 34px;
  font-weight: bold;
  color: #f7bc08;
  text-align: center;
}
.rankbox3 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 65px;
}
.boxs {
  position: relative;
  width: 176px;
  height: 100px;
  margin: 0 20px;
  text-align: center;
}
.line {
  width: 1px;
  height: 61px;
  background: #c3c3c3;
}
.text-name {
  width: 100%;
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 28px;
  font-weight: 500;
  color: #202020;
}
.unit-box {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}
.nums {
  width: 100%;
  font-size: 34px;
  font-weight: bold;
  color: #d81a1e;
}
.unit {
  font-size: 28px;
  font-weight: bold;
  color: #d81a1e;
}
.right-bottom {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
.number {
  font-size: 20px;
  font-weight: 500;
  color: #878787;
}
.tanktab {
  width: 222px;
  height: 70px;
}
.tanktabas {
  width: 100px;
  height: 34px;
}
.tanktabs {
  width: 65px;
  height: 34px;
}
::v-deep .van-tabs__line {
  background-color: transparent;
}
.tabBgc {
  position: relative;
  width: 128px;
  height: 90px;
}
::v-deep .van-tab--active {
  &.childrenA {
    background: url("../../assets/picture/an@2x.png") no-repeat center center;
  }
  width: 128px;
  height: 90px;
  text-align: center;
}
.tabtexts {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  font-size: 28px;
}
::v-deep .van-tab {
  text-align: center;
  color: #fff;
}
::v-deep .van-tabs {
  height: 100px;
}
.anwImg {
  position: relative;
  width: 100%;
  height: 140px;
  text-align: center;
}
.answnumb {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 203px;
  height: 77px;
}
h5 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  font-weight: bold;
  font-family: SimHei;
  color: #533408;
}
.transcript {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 133px;
  border-bottom: 1px solid #f2f2f2;
}
.onesBox {
  position: relative;
  width: 120px;
  height: 100%;
  margin: 0 30px;
  text-align: center;
}
.tranBox {
  position: absolute;
  top: 27px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  font-weight: 500;
  color: #929292;
}
.numsBox {
  position: absolute;
  bottom: 25px;
  left: 50%;
  width: 120px;
  transform: translateX(-50%);
  font-size: 28px;
  font-weight: bold;
  color: #323232;
}
.cell-box {
  position: relative;
  height: 100px;
}
.sortone {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 50px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  font-size: 28px;
  font-weight: 500;
  color: #ffb118;
  font-weight: bold;
}
.sortTwo {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 50px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 50px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  font-size: 28px;
  font-weight: 500;
  color: #18a5fe;
  font-weight: bold;
}
.sortThree {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 50px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  font-size: 28px;
  font-weight: 500;
  color: #ff810e;
  font-weight: bold;
}
.sort {
  position: absolute;
  top: 50%;
  left: -10px;
  transform: translateY(-50%);
  width: 70px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  font-weight: bold;
}
.headImg {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  width: 80px;
  height: 80px;
  text-align: center;
  border-radius: 10px;
}
.headItem {
  width: 80px;
  height: 80px;
  border-radius: 10px;
}
.img {
  width: 80px;
  height: 80px;
  border-radius: 10px;
}
.resultBox {
  position: absolute;
  top: 48%;
  left: 25%;
  transform: translateY(-50%);
  width: 250px;
  height: 80px;
}
.resulName {
  font-size: 28px;
  font-weight: 500;
  color: #180303;
}
.tewoBox {
  width: 100%;
  height: 19px;
  display: flex;
  align-items: center;
}
.resultNus {
  height: 19px;
  font-size: 20px;
  font-weight: 500;
  color: #6a6a6a;
}
.resultNu {
  height: 19px;
  font-size: 20px;
  font-weight: 500;
  color: #6a6a6a;
  margin-left: 30px;
}
.redmus {
  color: #d81a1e;
  font-style: normal;
}
.topBox {
  position: absolute;
  top: 0;
  right: 30px;
  width: 100px;
  height: 100px;
  text-align: center;
}
.topOne {
  width: 90px;
  height: 88px;
}
.topTwo {
  width: 94px;
  height: 96px;
}
.topThree {
  width: 108px;
  height: 100px;
}
ul {
  margin-top: 40px;
}
li {
  display: flex;
  flex-flow: column;
  width: 690px;
  margin: 0 auto;
  margin-top: 20px;
}

.first-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.serial {
  font-size: 28px;
  font-weight: bold;
  color: #373737;
}
.topic-text {
  display: flex;
  width: 80%;
  text-align: left;
  font-size: 28px;
  font-weight: bold;
  color: #373737;
}
.photo {
  width: 200px;
}
.right-text {
  width: 100px;
  font-size: 26px;
  font-weight: 500;
  color: #e82b2b;
  margin-left: 20px;
}
.right-texts {
  width: 100px;
  font-size: 26px;
  font-weight: 500;
  color: #16d616;
  margin-left: 20px;
}
.chunk-box {
  display: flex;
  flex-flow: column;
  width: 690px;
  background: #f2f2f2;
  border-radius: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.answs {
  left: 29px;
  font-size: 26px;
  font-weight: 500;
  color: #f8b15d;
  margin-left: 29px;
  margin-top: 43px;
}
.answs-text {
  margin-top: 20px;
  margin-bottom: 40px;
  font-size: 26px;
  font-weight: 500;
  color: #3a3a3a;
  margin-left: 29px;
}
.analysis {
  font-size: 26px;
  font-weight: 500;
  color: #5db1f8;
  margin-left: 29px;
}
.anlysis-text {
  width: 650px;
  font-size: 26px;
  font-weight: 500;
  color: #3a3a3a;
  margin-left: 29px;
}
.blankbox {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  text-align: center;
  margin-top: 120px;
}
.blankImg {
  width: 313px;
  height: 168px;
}
h4 {
  font-size: 28px;
  font-weight: 500;
  color: #787878;
  margin-top: 30px;
}
</style>

